import { ChangeDetectorRef, Component, forwardRef, Input, OnInit } from '@angular/core';
import {
  AbstractControl, ControlValueAccessor, UntypedFormBuilder, UntypedFormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR,
  ValidationErrors, Validator, Validators
} from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

import { FormGroupConfig } from 'core/form-config-type';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { AddressFormModel } from 'shared/forms/address-form/address-form.component';

export interface FieldResponseFormModel {
  // Model of form value
  name: string;
  address?: AddressFormModel;
}

@Component({
  selector: 'app-field-response-form',
  templateUrl: './field-response-form.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FieldResponseFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FieldResponseFormComponent),
      multi: true
    }
  ]
})
export class FieldResponseFormComponent
  extends WithDisposableSubject()
  implements OnInit, ControlValueAccessor, Validator {
  formGroup: UntypedFormGroup;

  @Input() isAddress: boolean;

  private _onTouched = () => { };

  private _onChangeCallback = () => { };

  constructor(
    private _fb: UntypedFormBuilder,
    private _cd: ChangeDetectorRef
  ) {
    super();

  }

  ngOnInit() {

    const config: FormGroupConfig<FieldResponseFormModel> = {
      name: ['', [Validators.required]],
    };

    if (this.isAddress) {
      config.address = [null];
    }

    this.formGroup = this._fb.group(config);

    this.formGroup.valueChanges.pipe(
      takeUntil(this.disposer)
    ).subscribe(() =>
        // Wrapping in a timeout to avoid ExpressionChangedAfterItHasBeenCheckedError
      setTimeout(() => this.handleDataChange(), 1)
    );
  }


  /** Control Value Accessor Implementmenation */
  writeValue(obj: FieldResponseFormModel): void {
    if (obj) {
      this.formGroup.patchValue(obj, { emitEvent: false });
      this.handleDataChange();
    }
  }

  registerOnChange(fn: any): void {
    this._onChangeCallback = () => fn(this.formGroup.value);

  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.formGroup.disable();
    } else {
      this.formGroup.enable();
    }
  }

  /** Validator Implementation */
  validate(control: AbstractControl): ValidationErrors {
    if (this.formGroup.valid) {
      return null;
    }
    return { response: true };
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.formGroup.valueChanges.pipe(
      takeUntil(this.disposer)
    ).subscribe(fn);
  }

  private handleDataChange() {
    this._cd.markForCheck();
    if (this._onChangeCallback) {
      this._onChangeCallback();
    }
  }
}
